(function () {
  var body = document.body || document.getElementsByTagName('body')[0];
  if (!body) return;

  // ¿Es página de carrito?
  var isCart =
    body.className.indexOf('template-cart') !== -1 ||
    document.querySelector('[data-cart-page]');

  if (!isCart) return;

  // NO tocamos history.scrollRestoration aquí,
  // para no pelearnos con el navegador si él decide hacer algo raro.

  function getCartContainer() {
    return (
      document.querySelector('[data-cart-page]') ||
      document.querySelector('[data-section-type="cart-template"]') ||
      document.querySelector('main') ||
      document.body
    );
  }

  // Esta función corrige el scroll si hay un hueco grande arriba del carrito
  function fixScrollIfGap() {
    var container = getCartContainer();
    if (!container) return;

    var rect = container.getBoundingClientRect();

    // Si el inicio del carrito está muy abajo (espacio en blanco arriba)
    // Por ejemplo, más de 120px desde la parte superior de la pantalla
    if (rect.top > 120) {
      var target = window.scrollY + rect.top - 20; // lo subimos casi al tope
      window.scrollTo(0, target);
    }
  }

  function scheduleFixes() {
    // Lo llamamos varias veces porque el carrito puede re-renderizarse
    [50, 150, 300, 600, 1000].forEach(function (t) {
      setTimeout(fixScrollIfGap, t);
    });
  }

  // Cuando la página de carrito carga
  window.addEventListener('load', function () {
    scheduleFixes();
  });

  // Cuando volvemos con botón atrás / bfcache
  window.addEventListener('pageshow', function () {
    scheduleFixes();
  });

  // Cuando el tema actualiza el carrito vía AJAX (agregar/quitar productos)
  document.addEventListener('cart:updated', function () {
    scheduleFixes();
  });
})();
